/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Models_StoreExternalLinkSettings = {
  isEnabled?: boolean;
  url?: string;
  linkType?: Luci_Shopping_Api_Models_StoreExternalLinkSettings.linkType;
  displayText?: string;
};
export namespace Luci_Shopping_Api_Models_StoreExternalLinkSettings {
  export enum linkType {
    VIRTUAL_WAREHOUSE = 'VirtualWarehouse',
  }
}

